/// <amd-module name="VSS/Features/Charts/Internal/AccessibilityUtilities" />
import Highcharts = require("highcharts");
import { format } from "VSS/Core/Util/String";
import * as Charts_Resources from "VSS/Features/Charts/Resources";
import * as Charts_Contracts from "../Contracts";
import { HighchartsExtendedPointObject } from "./InternalContracts";

export function translateAccessibilityOptions(chartOptions: Charts_Contracts.ChartProps): Highcharts.AccessibilityOptions {
    const accessibility: Highcharts.AccessibilityOptions = {};
    
    if (chartOptions.accessibility && chartOptions.accessibility.enabled !== undefined) {
        accessibility.enabled = chartOptions.accessibility.enabled;
    }

    // Highcharts expects date plotted chart content to normally expose date information as x-y tuples from the series.
    // As the Day in month mode series data operates as 1D array of y values in lock-step without corresponding x-axis data points, the default accessibility pointDescriptionFormatter doesn't know to get dates from the x-axis.
    // We need to explicitly provide the aria labels for dates to show the supplied category date, rather than have it treat index of series items as dates.
    if (chartOptions.xAxis && chartOptions.xAxis.formatAccessibleLabelsUsingAxisCategories) {
        // Note: This doesn't attempt to apply this as formatter pattern, due to heavy awareness of chart option state.
        // This isn't an extensibility pattern we want to generalize, but rather a data hygiene mitigation.
        // Going forward, the highcharts default formatter can and should be used as a default for date charts, by supplying tuple or array style data points for date oriented charts and transitioning this to be a non-default opt-in.
        if(!accessibility.point) {
            accessibility.point = {};
        }

        accessibility.point.descriptionFormatter = (point: HighchartsExtendedPointObject): string => {
            const xValue = chartOptions.xAxis.labelValues[point.index];
            const formattedXValue = xValue instanceof Date ? xValue.toDateString() : xValue;
            const xComponent =
                point.index != null ? format(Charts_Resources.A11yLabelPrefixFormat, point.index + 1, formattedXValue) : formattedXValue;

            // Only show the series name if there are multiple series, otherwise just provide the value.
            const hasMultipleSeries = chartOptions.series.length > 1;
            const roundingAmount = Math.pow(10, 2); // Two significant digits.
            const yValue = Math.round(point.y * roundingAmount) / roundingAmount;
            const singleSeriesYValue = chartOptions.yAxis && chartOptions.yAxis.title ? chartOptions.yAxis.title + " : " + yValue : yValue;
            const yComponent = hasMultipleSeries ? format(Charts_Resources.A11yLabelPrefixFormat, yValue, point.series.name) : singleSeriesYValue;

            return format(Charts_Resources.A11yLabelElementSeparatorFormat, xComponent, yComponent);
        };
    }

    return accessibility;
}
